import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
// TODO: maintenance windown
// import { MaintenaceWindow } from 'pages'
import reportWebVitals from './reportWebVitals'

ReactDOM.render(
	<BrowserRouter>
		<React.StrictMode>
			{/* TODO: maintenance windown */}
			{/* <MaintenaceWindow /> */}
			<App />
		</React.StrictMode>
	</BrowserRouter>,
	document.getElementById('root')
)
reportWebVitals()
